import React from "react";
import ExperienceSection from "./ExperienceSection";
import EducationSection from "./EducationSection";
import SkillsSection from "./SkillsSection";
import AchievementsSection from "./AchievementsSection";
import SocialImpactSection from "./SocialImpactSection";

const SectionContent = ({
  section,
  location,
  updateSection,
  addSectionItem,
  updateSectionItem,
  removeSectionItem,
}) => {
  // Add debugging to see what's being passed
  console.log("SectionContent rendering:", {
    sectionId: section?.id,
    sectionType: section?.type,
    location: location,
    hasItems: !!section?.items,
    itemsLength: section?.items?.length,
  });

  // Profile section (simple textarea)
  if (section.type === "profile") {
    return (
      <div className="section-content">
        <label className="form-label">
          Professional Summary
          <span className="label-hint">
            Write a compelling 3-4 sentence summary that highlights your key
            strengths and career objectives
          </span>
        </label>
        <textarea
          value={section.content || ""}
          onChange={(e) =>
            updateSection(location, section.id, { content: e.target.value })
          }
          className="form-textarea"
          placeholder="Experienced professional with a proven track record in... Passionate about... Seeking to leverage my expertise in..."
          rows={4}
        />
      </div>
    );
  }

  // Experience, Volunteer, and Projects sections
  if (["experience", "volunteer", "projects"].includes(section.type)) {
    return (
      <ExperienceSection
        section={section}
        location={location}
        updateSectionItem={(itemId, updates) => {
          console.log("SectionContent calling updateSectionItem with:", {
            location,
            sectionId: section.id,
            itemId,
            updates,
          });
          updateSectionItem(location, section.id, itemId, updates);
        }}
        removeSectionItem={(itemId) => {
          console.log("SectionContent calling removeSectionItem with:", {
            location,
            sectionId: section.id,
            itemId,
          });
          removeSectionItem(location, section.id, itemId);
        }}
        addSectionItem={(itemTemplate) => {
          console.log("SectionContent calling addSectionItem with:", {
            location,
            sectionId: section.id,
            itemTemplate,
          });
          addSectionItem(location, section.id, itemTemplate);
        }}
      />
    );
  }

  // Education section
  if (section.type === "education") {
    return (
      <EducationSection
        section={section}
        updateSectionItem={(itemId, updates) => {
          console.log(
            "SectionContent calling updateSectionItem for education:",
            {
              location,
              sectionId: section.id,
              itemId,
              updates,
            }
          );
          updateSectionItem(location, section.id, itemId, updates);
        }}
        removeSectionItem={(itemId) => {
          removeSectionItem(location, section.id, itemId);
        }}
        addSectionItem={(itemTemplate) => {
          addSectionItem(location, section.id, itemTemplate);
        }}
      />
    );
  }

  // Skills sections (competencies, languages, interests, technical)
  if (
    ["competencies", "languages", "interests", "technical"].includes(
      section.type
    )
  ) {
    return (
      <SkillsSection
        section={section}
        location={location}
        updateSection={updateSection}
      />
    );
  }

  // Achievements sections (certifications, awards, achievements, publications)
  if (
    ["certifications", "awards", "achievements", "publications"].includes(
      section.type
    )
  ) {
    return (
      <AchievementsSection
        section={section}
        updateSectionItem={(itemId, updates) => {
          console.log(
            "SectionContent calling updateSectionItem for achievements:",
            {
              location,
              sectionId: section.id,
              itemId,
              updates,
            }
          );
          updateSectionItem(location, section.id, itemId, updates);
        }}
        removeSectionItem={(itemId) => {
          removeSectionItem(location, section.id, itemId);
        }}
        addSectionItem={(itemTemplate) => {
          addSectionItem(location, section.id, itemTemplate);
        }}
      />
    );
  }

  // Social Impact section
  if (section.type === "social") {
    return (
      <SocialImpactSection
        section={section}
        updateSectionItem={(itemId, updates) => {
          console.log("SectionContent calling updateSectionItem for social:", {
            location,
            sectionId: section.id,
            itemId,
            updates,
          });
          updateSectionItem(location, section.id, itemId, updates);
        }}
        removeSectionItem={(itemId) => {
          removeSectionItem(location, section.id, itemId);
        }}
        addSectionItem={(itemTemplate) => {
          addSectionItem(location, section.id, itemTemplate);
        }}
      />
    );
  }

  // Default fallback for any unhandled section types
  return (
    <div className="section-content">
      <p className="text-gray-500 text-sm">
        Content editor for "{section.type}" section is not yet implemented.
      </p>
    </div>
  );
};

export default SectionContent;
